import { render, staticRenderFns } from "./AppStart.vue?vue&type=template&id=48f98a54&scoped=true&"
import script from "./AppStart.vue?vue&type=script&lang=ts&"
export * from "./AppStart.vue?vue&type=script&lang=ts&"
import style0 from "./AppStart.vue?vue&type=style&index=0&id=48f98a54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f98a54",
  null
  
)

component.options.__file = "AppStart.vue"
export default component.exports